import { render } from "./RateModifierInsurance.vue?vue&type=template&id=15ed2e81"
import script from "./RateModifierInsurance.vue?vue&type=script&lang=js"
export * from "./RateModifierInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__